
// export default ProfessionalFAQ;

import React from "react";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Search } from "lucide-react";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";


const ProfessionalFAQWeb = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const [searchTerm, setSearchTerm]= useState("");
  const [faqs, setFaqs]= useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = React.useState("");
  useEffect(() => {
      dispatch(hitGetSettingsApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          setFaqs(response.payload.data.faqProfessional);
        }
      });
  }, [dispatch, navigate]);


  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  return (
    <div className="custom_container padding_top">
      <div className="faq-container">
      <div className="faq-header">
        <h1>FAQ for Professionals</h1>
        <p>
          Please reach out to support if your question cannot be answered below.
        </p>
      </div>

      <div className="search-box">
        <Search className="search-icon" size={18} />
        <input
          type="text"
          placeholder="Search FAQs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="faq-list">
        {filteredFaqs.map((faq, index) => (
          <div key={faq._id} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleQuestion(faq._id)}
            >
              <span className="question-text">
                 {faq.question}
              </span>
              <ChevronDown
                className={`chevron ${openQuestion === faq._id ? "open" : ""}`}
                size={20}
              />
            </button>

            {openQuestion === faq._id && (
              <div className="faq-answer">
                {index === 0 && (
                  <div className="tooltip">
                    <div className="tooltip-content">i</div>
                  </div>
                )}
                  <p dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
              </div>
            )}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default ProfessionalFAQWeb;
